module.exports = __webpack_public_path__ + "img/chevron-left_1.5eec6d62.svg";